import {
  ApiBlueprint,
  createFrontendModule,
  gitlabAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { cicdStatisticsApiRef } from '@backstage-community/plugin-cicd-statistics';
import { PortalCicdStatisticsApiGitlab } from './CicdStatisticsApiGitlab';

const cicdStatisticsGitlabApi = ApiBlueprint.make({
  name: 'gitlab-api',
  params: defineParams =>
    defineParams({
      api: cicdStatisticsApiRef,
      deps: { gitlabAuthApi: gitlabAuthApiRef },
      factory: ({ gitlabAuthApi }) =>
        new PortalCicdStatisticsApiGitlab(gitlabAuthApi),
    }),
});

export const cicdStatisticsModule = createFrontendModule({
  pluginId: 'cicd-statistics',
  extensions: [cicdStatisticsGitlabApi],
});
